var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[_c('kt-panel',[(_vm.is_current_user_fetched)?_c('kt-panel-body',[(_vm.$can('update-info','deposit-gateway'))?_c('div',[_c('manage-details')],1):_c('div',[_c('common-details')],1)]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }